import React from 'react';

import { Snag, Email } from './styles';

const SnagSection = () => {
  return (
    <Snag>
      <p>Hit a Snag?</p>
      <span>Contact us at 888-383-4483</span>
      <span>{' '}or</span>
      <Email>
        <span>financialadvisors@vanguardcharitable.org</span>
      </Email>
    </Snag>
  );
};

export default SnagSection;
